import { render } from "./HeaderDashboard.vue?vue&type=template&id=1211dd26&scoped=true"
import script from "./HeaderDashboard.vue?vue&type=script&lang=js"
export * from "./HeaderDashboard.vue?vue&type=script&lang=js"

import "./HeaderDashboard.vue?vue&type=style&index=0&id=1211dd26&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1211dd26"]])

export default __exports__